module.exports = __webpack_public_path__ + "static/media/venue_jiu01.1c0f9077.jpg";